import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../App';

function Sidebar() {
  const { user, logout } = useAuth();

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h2>Prebid Monitor</h2>
        <p>{user?.email}</p>
      </div>
      <nav className="sidebar-nav">
        {user?.role === 'admin' && (
          <NavLink to="/admin" className={({ isActive }) => isActive ? 'active' : ''}>
            Publishers
          </NavLink>
        )}
        <NavLink to="/dashboard" className={({ isActive }) => isActive ? 'active' : ''}>
          Dashboard
        </NavLink>
        <NavLink to="/trends" className={({ isActive }) => isActive ? 'active' : ''}>
          Trends
        </NavLink>
      </nav>
      <div className="sidebar-footer">
        <button onClick={logout}>Logout</button>
      </div>
    </div>
  );
}

export default Sidebar;
